import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  academyTopicsSelector,
  CLASS_CREATION_STATUSES,
} from 'features/classCreation';
import ClassCreationTrackerRow from '../ClassCreationTrackerRow';
import styles from './ClassCreationTrackerTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function ClassCreationTrackerTable({ classes, classStatuses }) {
  const academyTopics = useSelector(academyTopicsSelector);

  const selectedClasses = useMemo(() => {
    return classes.filter(
      (cls) => academyTopics[cls.academy_topic.id]?.selected
    );
  }, [academyTopics, classes]);

  return (
    <Table className={styles.root}>
      <TableHead className={styles.header}>
        <TableRow>
          <TableCell className={styles.classTitle}>Classes</TableCell>
          <TableCell className={styles.primaryInstructor}>
            Primary Instructor
          </TableCell>
          <TableCell className={styles.secondaryInstructor}>
            Secondary Instructor
          </TableCell>
          <TableCell className={styles.otherInstructors}>
            Other Instructor(s)
          </TableCell>
          <TableCell className={styles.date}>Date & Time</TableCell>
          <TableCell className={styles.status}>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {selectedClasses.map((cls) => {
          return (
            <ClassCreationTrackerRow
              key={cls.id}
              cls={cls}
              status={
                classStatuses
                  ? classStatuses[cls.academy_topic.id]
                  : CLASS_CREATION_STATUSES.pending
              }
            />
          );
        })}
      </TableBody>
    </Table>
  );
}

export default ClassCreationTrackerTable;
